import * as React from 'react';
import './style/index.scss';
export const LabeledValue = (props) => {
    return (React.createElement("div", { className: "labeled-value" },
        React.createElement("div", { className: "labeled-value__value" }, props.value),
        React.createElement("div", { className: "labeled-value__label" }, props.label)));
};
export default LabeledValue;
